import { Navigate, Outlet } from "react-router-dom"; // 👈 Import Navigate
import { Navigation, Sidebar } from "../components/navigation";

import { AutoLogout } from "./AutoLogout";
import { Loader } from "../components/loader";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { responsiveness } from "../assets/styles/parameters";
import { store } from "../redux/store";
import styled from "styled-components";
import { useSelector } from "react-redux";

export const ProtectedRoutes = () => {
  const { userInfo } = useSelector((state) => state.users);
  const persistor = persistStore(store);
  const isAuthenticated = !!userInfo?.token;

  return isAuthenticated ? (
    <>
      <AutoLogout>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <Layout>
            <Sidebar />
            <Navigation />
            <Outlet />
          </Layout>
        </PersistGate>
      </AutoLogout>
    </>
  ) : (
    // This will now correctly redirect to the /login route
    <Navigate to="/login" replace />
  );
};

const Layout = styled.div`
  display: grid;
  grid-template-areas:
    "sidebar navigation navigation navigation "
    "sidebar header header header"
    "sidebar main main main"
    "sidebar main main main"
    "sidebar main main main";
  grid-template-columns: 5% 1fr 1fr 1fr;

  @media screen and (max-width: ${responsiveness.mobile1}) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "navigation"
      "sidebar"
      "header"
      "main";
  }
`;
